import { MutationDefinition } from '@reduxjs/toolkit/query'

import { baseQueryWithNotifications } from '@redux/api/config'
import { fetchContextMenuConfigsByIds } from '@redux/api/helpers/fetchContextMenuConfigsByIds'

import { URLS } from '@constants'
import { GETForm } from '@types'

type FetchTimelineConfigFn = MutationDefinition<
  { code: string | null; cacheId?: string },
  typeof baseQueryWithNotifications,
  string,
  GETForm,
  'commonApi'
>['queryFn']

export const fetchEnrichedFormConfigByCode: NonNullable<FetchTimelineConfigFn> = async (
  params,
  api,
  _,
  baseQuery
) => {
  const queryResult = await baseQuery({
    url: `${URLS.FRONT_CFG}/form/code/${params.code}`,
    method: 'GET',
  })

  if (queryResult.error) {
    return { error: queryResult.error }
  }

  const configData = queryResult.data as GETForm

  const [contextMenus] = await Promise.all([
    fetchContextMenuConfigsByIds({
      contextMenuIds: configData.contextMenuId ? [configData.contextMenuId] : [],
      api,
    }),
  ])

  return {
    data: {
      ...configData,
      contextMenu: contextMenus?.get(configData.contextMenuId),
    },
  }
}
